// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3zE9n","modalForm":"UpgradeEpcsModal_modalForm__duWb-","modalFooter":"UpgradeEpcsModal_modalFooter__2iv4u"};